export default __webpack_public_path__ + "static/media/fd-blue.49b23897.svg";